import api from "./api";
import { errorHandling } from "./error.handling";

// const basePath = `${process.env.REACT_APP_API_VEHICLE_BASE_URL}/v1/carcolor`;
const basePath = "https://nc8.olharfixo.com.br/Vehicles/api/v3";


async function create(payload) {
  try {
    let response = await api.post(`${basePath}/colors`, JSON.stringify(payload));
    let treated = errorHandling.handleResponse(response, "colorService.create");
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "colorService.create");
    return null;
  }
}

async function update(payload) {
  try {
    let response = await api.put(`${basePath}/colors/${payload.id}`, JSON.stringify(payload));
    let treated = errorHandling.handleResponse(response, "colorService.update");
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "colorService.update");
    return null;
  }
}

async function list() {
  
  try {
    let response = await api.get(`${basePath}/colors`);
    let treated = errorHandling.handleResponse(response, "colorService.list");
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "colorService.list");
    return null;
  }
}

async function remove(id) {
  try {
    let response = await api.delete(`${basePath}/groups/${id}/color`);
    let treated = errorHandling.handleResponse(response.status, "colorService.remove");
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "colorService.remove");
    return null;
  }
}

async function sendColor(colorId, id) {
  try {
    let response = await api.patch(`${basePath}/groups/${id}/config/color`, JSON.stringify({colorId}));
    let treated = errorHandling.handleResponse(response, "colorService.sendColor");
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "colorService.sendColor");
    return null;
  }
}


export const colorService = {
  create,
  update,
  list,
  remove,
  sendColor
};
